import { Text } from '@scality/core-ui';
import styled from 'styled-components';

export const XXLargeText = styled(Text)`
  font-size: xx-large;
  font-weight: 700;
  line-height: unset;
  color: white;
`;

export const XXLargeGradientText = styled(XXLargeText)`
  background: ${(props) => props.theme.buttonPrimary};
  background-clip: text;
  color: transparent;
  filter: brightness(1.5);
`;
